<template>
  <div class="jazeMainPanel" style="height: 100%;">
    <div class="jazePanelContent jazePanelContent--scrollable">
      <div class="unifiSettingsContainer">
        <form ref="locationConfigForm" id="locationConfigForm" class="appForm appForm--cozy is-validation-hidden" :class="formClass">
          <div class="unifiSettingsHeader">
            <div class="unifiSettingsHeader__title">Location Configuration</div>
          </div>
          <fieldset class="appFieldset appFieldset--quiet">
            <div class="jazeAlert jazeAlert--danger row col-12" v-if='errorShow'>
              <div class="col-6">
                <strong>{{errorMessage}}</strong>
              </div>
            </div>
            <div class="unifiSettingsSection">
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 1</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel1Name" autofocus="true" v-model="locationLevel1Name">
                </div>
              </div>
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 2</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel2Name" v-model="locationLevel2Name">
                </div>
              </div>
           
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 3</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel3Name" v-model="locationLevel3Name">
                </div>
              </div>
              <div class="appRow">
                <div class="col--sm3">
                  <label class="appLabel appLabel--primary appLabel--boxAlign">Location Level 4</label>
                </div>
                <div class="col--sm5 appFormGroup appFormGroup--cozy">
                  <input class="input--full" type="text" name="locationLevel4Name" v-model="locationLevel4Name">
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <div class="appFormFooter appFormFooter--standalone appFormFooter--flush appFormFooter--dark">
           <div class="appFormFooter__right" v-if="genConfigDetails.visible == 'visible'">
            <button class="appMainButton busyToggle" type="button" @click="subZoneModalShow=true" v-if="genConfigDetails.edition == 'isp'"> SubZones Restrictions</button>
            <button class="appMainButton busyToggle" type="button" @click="subZoneModalShow=true" v-else> SubAccounts Restrictions</button>

            <button class="appMainButton busyToggle" type="button" @click="pushZonefn()" v-if="genConfigDetails.edition == 'isp'"> Add to All SubZones</button>
            <button class="appMainButton busyToggle" type="button" @click="pushZonefn()" v-else> Add to All SubAccounts</button>

            <button class="appMainButton appMainButton--primary busyToggle" type="submit" @click="saveLocationConfig"> Save</button>
          </div>

        </div>
      </div>
    </div>
    <div class="jazeModalContainer jazeModalContainer--blackout jazeModalContainer--centered" v-if="subZoneModalShow">
      <div class="pos-relative" dialog-window>
        <div dialog-content>
          <div class="jazeModal jazeModal--small unifiSpeedTestModal unifiSpeedTestModal--inProgress">
            <form class="jazeForm jazeModal jazeModal--small unifiAddUser">
              <div class="jazeModal__header pb-0">
                <div class="jazeHeader jazeHeader--centered">
                  <div class="jazeHeader__title"> Save </div>
                  <svg viewBox="0 0 14 14" class="jazeIcon jazeIcon--actionable" @click="subZoneModalShow=false">
                    <g transform="translate(8.5 7.2071) rotate(45) translate(-9 -9)">
                      <path d="m9.0294 8.7071h8v1h-8v8h-1v-8h-8v-1h8v-8h1v8z" />
                    </g>
                  </svg>
                </div>
              </div>
              <div class="jazeModal__main">
                <div class="jazeModalContent pb-1">
                  <div class="container container--horizontal-cozy container--vertical-comfy">
                    <div class="row">
                      <div class="col jazeFormGroup jazeFormGroup--flex">
                        <label class="jazeLabel jazeLabel--primary" v-if="genConfigDetails.edition =='isp'">Allow/Deny sub-zones to change Location Config settings</label>
                        <label class="jazeLabel jazeLabel--primary" v-else>Allow/Deny sub-accounts to change Location config settings</label> &emsp;
                        <div class="toggle appToggle appToggle--light" data-on="On" data-off="Off">
                          <input type="checkbox" v-model="switchcheckboxPay" id="switchcheckboxPay" :checked="genConfigDetails.subAccountsCanNotChangeLocationConfigSettings == 'Yes' ? true : false">
                          <label for="switchcheckboxPay"> </label>
                        </div>
                      </div>
                    </div>
                    <div class="appType--micro appType--quiet italicized" v-if="genConfigDetails.edition =='isp'">
                      Note: If it is 'ON', sub-zones can not change Location Config settings .
                    </div>
                    <div class="appType--micro appType--quiet italicized" v-else>
                      Note: If it is 'ON', sub-accounts can not change Location Config settings .
                    </div>
                  </div>
                </div>
              </div>
              <div class="jazeModal__footer">
                <div class="jazeButtonGroup jazeButtonGroup--cozy">
                  <button class="jazeButton jazeButton--secondary" type="button" @click="subZoneModalShow=false">Cancel</button>
                  <button class="jazeButton jazeButton--primary submitForm" type="button" @click="allowSubZones">Yes</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <SuccessToaster :successMessage='successMessage' :sucesstoasterShow='successtoaster' v-if='successtoaster'></SuccessToaster>
    <ErrorToaster :errorMessage='errorMessage' :errortoasterShow='errortoaster' v-if='errortoaster'></ErrorToaster>
    <PushToSubZone v-if="pushModal" :selected='selected' :edition="genConfigDetails.edition" @extend-clicked-push-detail="onclickclose" :subAccounts="subaccDetailsGetter" :from="'locationConfig'" :modalType="'subAccountsOnly'" ></PushToSubZone>
  </div>
</template>

<script setup>
import { ref,computed,watch,watchEffect,onMounted,onBeforeUnmount } from 'vue';
import Treeselect from "jaze-vue3-treeselect";
import SuccessToaster from "@/components/Toaster/SuccessToaster.vue";
import ErrorToaster from "@/components/Toaster/ErrorToaster.vue";
import PushToSubZone from "@/components/Profiles/PushToSubZoneModal.vue";
import moment from "moment";
import "moment-timezone";
import VueCtkDateTimePicker from "jaze-ctk-date-time-picker";

import { storeToRefs } from "pinia";
import {overrideIsSelected} from '@/overrides/vue3-treeselect'
import { uselayoutStore } from '@/store/layoutstore'
import { usesettingsStore } from '@/store/settingsstore'
const layoutStore = uselayoutStore()
const { subaccDetails } = storeToRefs(layoutStore)
const subaccDetailsGetter= computed(() => subaccDetails.value);

    const genConfigDetails = ref( [] )
    const formClass = ref( "" )
    const errorShow = ref( false )
    const errorMessage = ref( "" )
      
    const successtoaster = ref( false )
    const successMessage = ref( "" )
    const errortoaster = ref( false )
    const locationLevel1Name = ref( "Area" )
    const locationLevel2Name = ref( "Street" )
    const locationLevel3Name = ref( "Building" )
    const locationLevel4Name = ref( "House" )
    const switchcheckboxPay = ref( false )
    const subZoneModalShow = ref( false )
    const optionaAllSelect = ref( "all" )
   const pushModal = ref( false )
   const selected = ref( [] )

    const settingsStore = usesettingsStore()
    const { locationConfigDetails } = storeToRefs(settingsStore)
    const locationConfigGetter = computed(() => locationConfigDetails.value);

    onMounted(() => {
      getLocationConfigDetails();
    })
    onBeforeUnmount(() => {
      settingsStore.clearSettingsState();
    })
    watch(locationConfigGetter,() => {
      genConfigDetails.value = locationConfigGetter.value;
      
      if (
        genConfigDetails.value.locationLevel1Name != undefined &&
        genConfigDetails.value.locationLevel1Name != ""
      ) {
        locationLevel1Name.value = genConfigDetails.value.locationLevel1Name;
      }
      if (
        genConfigDetails.value.locationLevel2Name != undefined &&
        genConfigDetails.value.locationLevel2Name != ""
      ) {
        locationLevel2Name.value = genConfigDetails.value.locationLevel2Name;
      }
      
      if (
        genConfigDetails.value.locationLevel3Name != undefined && genConfigDetails.value.locationLevel3Name !=""
      ) {
        locationLevel3Name.value = genConfigDetails.value.locationLevel3Name;
      }

      if (
        genConfigDetails.value.locationLevel4Name != undefined && genConfigDetails.value.locationLevel4Name !=""
      ) {
        locationLevel4Name.value = genConfigDetails.value.locationLevel4Name;
      }

      if (
        genConfigDetails.value.subAccountsCanNotChangeLocationConfigSettings == "Yes"
      ) {
        switchcheckboxPay.value = true;
      }

    })

    const getLocationConfigDetails = () => {
      if (Object.keys(locationConfigGetter.value).length == 0) {
        settingsStore.fetchLocationConfiguration();
      } else {
        genConfigDetails.value = locationConfigGetter.value;
      }
    }
    const saveLocationConfig = (e) => {
      successtoaster.value = false;
      errortoaster.value = false;
      e.preventDefault();
      errorShow.value = false;
      var form = document.getElementById('locationConfigForm');
      const formData = new FormData(form); // reference to form element
      const postData = {}; // need to convert it before using not with XMLHttpRequest
      for (let [key, val] of formData.entries()) {
        Object.assign(postData, { [key]: val });
      }
      settingsStore.locationConfigurationSubmit(postData).then(  
        response => {
          successtoaster.value = true;
          successMessage.value = response;
          setTimeout(
            function() {
              successtoaster.value = false;
            }.bind(this),
            2000
          );
        },
        error => {
          errortoaster.value = true;
          errorMessage.value = error;
          setTimeout(
            function() {
              errortoaster.value = false;
            }.bind(this),
            15000
          );
          console.log(error);
        }
      );
    }
  const allowSubZones = () => {
    successtoaster.value = false;
    errortoaster.value = false;
    if (switchcheckboxPay.value == true) {
      var check = "on";
    } else {
      var check = "off";
    }
    var data = {
      switchCheckBoxValue: check,
      attribute: "subAccountsCanNotChangeLocationConfigSettings",
      type: "locationConfig",
    };
    settingsStore.saveSubAccountPermissionSettings(data).then(  
      (response) => {
        subZoneModalShow.value = false;
        successtoaster.value = true;
        successMessage.value = response;
        setTimeout(
          function () {
            successtoaster.value = false;
          }.bind(this),
          2000
        );
      },
      (error) => {
        errortoaster.value = true;
        errorMessage.value = error;
        setTimeout(
          function () {
            errortoaster.value = false;
          }.bind(this),
          15000
        );
        console.log(error);
      }
    );
  }
  const onclickclose = (value) => {
    pushModal.value = value;
  }
  const pushZonefn = () => {
    pushModal.value = !pushModal.value;
  }

</script>
